import { Icon } from "@iconify/react"
import { TypographySmall, TypographySmallMuted } from "@/components/ui/typography.jsx"
import { useNavigate, useLocation } from "react-router-dom"
import { SpaceSelector } from "@/components/space-selector/SpaceSelector"

export const SettingsSubNavbar = () => {
    const navigate = useNavigate()
    const { pathname } = useLocation()

    // Update isActive to match the correct path format
    const isActive = (path) => pathname.includes(`settings/${path}`)

    // Create a helper function to handle navigation
    const navigateTo = (path) => {
        navigate(`settings/${path}`)
    }

    return (
        <div className="p-3 flex flex-col gap-5 h-full overflow-y-auto">
            <div className="flex flex-col gap-1">
                <TypographySmall className="flex items-center gap-2">
                    <Icon icon="eos-icons:organisms" className="h-4 w-4" />
                    Account
                </TypographySmall>
                <div className="flex flex-col mt-2 gap-1">
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('account/general') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('account/general')}
                    >
                        General
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('account/spaces') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('account/spaces')}
                    >
                        Spaces
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('account/data-connections') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('account/data-connections')}
                    >
                        Data Connections
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('account/members') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('account/members')}
                    >
                        Members
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('account/billing') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('account/billing')}
                    >
                        Plan & Billing
                    </TypographySmallMuted>
                </div>
            </div>

            <div className="flex flex-col gap-1">
                <TypographySmall className="flex items-center gap-2">
                    <Icon icon="material-symbols-light:planet-outline-rounded" className="h-4 w-4 flex-shrink-0" />
                    Space
                </TypographySmall>
                <div className="flex flex-col mt-2 gap-1">
                    <SpaceSelector size="sm" />
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('space/general') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/general')}
                    >
                        General
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('space/data-sources') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/data-sources')}
                    >
                        Data Sources
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('space/data-config') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/data-config')}
                    >
                        Data Config
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('space/members') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/members')}
                    >
                        Members
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('space/naming-conventions') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/naming-conventions')}
                    >
                        Naming Conventions
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('space/custom-metrics') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/custom-metrics')}
                    >
                        Custom Metrics
                    </TypographySmallMuted>
                </div>
            </div>

            <div className="flex flex-col gap-1">
                <TypographySmall className="flex items-center gap-2">
                    <Icon icon="humbleicons:sparks" className="h-4 w-4" />
                    AI Settings
                </TypographySmall>
                <div className="flex flex-col mt-2 gap-1">
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('space/ai-context') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/ai-context')}
                    >
                        Basic Context
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('space/ai-knowledge') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/ai-knowledge')}
                    >
                        Space Knowledge
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('space/ai-instructions') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/ai-instructions')}
                    >
                        Instructions
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('space/ai-preferences') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/ai-preferences')}
                    >
                        Learned Preferences
                    </TypographySmallMuted>
                </div>
            </div>

            <div className="flex flex-col gap-1">
                <TypographySmall className="flex items-center gap-2">
                    <Icon icon="solar:user-broken" className="h-4 w-4" />
                    My User
                </TypographySmall>
                <div className="flex flex-col gap-1">
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px] ${isActive('user/details') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('user/details')}
                    >
                        General
                    </TypographySmallMuted>
                </div>
            </div>

            <div className="mt-auto pt-4">
                <a
                    href="https://help.upspring.ai"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-muted-foreground hover:text-primary hover:underline flex items-center gap-2 cursor-pointer hover:bg-accent px-3 py-1.5 rounded-lg transition !text-[13px]"
                >
                    <Icon icon="mdi:help-circle-outline" className="h-4 w-4" />
                    Need Help?
                </a>
            </div>
        </div>
    )
}